import styled from 'styled-components'

const LeaveApprovalSc = styled.div`
  width: 100vw;
  position: absolute;
  top: 55px;
  padding: 20px;
  .leave-approval-navbar {
    position: fixed;
  }
  .individual-page {
    width: 95vw;
    height: 100vh;
    padding: 1.2em;
  }
  .leave-approval-name-card {
    display: flex;
    gap: 20px;
    align-items: center;
  }
  .leave-approval-first-card {
    display: flex;
    justify-content: space-between;
    padding: 5px;
    padding-top: 40px;
  }
  .leave-approval-emp-image {
    width: 80px;
  }
  .leave-approval-right-side {
    background-color: #edecec;
    width: 600px;
    padding: 50px;
    margin: 20px;
    display: flex;
    justify-content: space-around;
    text-align: center;
    border-radius: 5px;
  }
  .total-leave {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .leave-consumed {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .leave-balance {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .total-leave-number {
    background-color: #1e59d9;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }
  .consumed-leave-number {
    background-color: #dd1e11;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }
  .balance-leave-number {
    background-color: #11dd32;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100%;
  }
  .request-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
  }
  .request-box > div {
    padding-left: 10px;
  }
  .request-conatiner {
    background-color: #edecec;
    padding: 30px;
    width: 90vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 30px;
    border-radius: 8px;
  }

  .leave-wfh-container {
    width: 100vw;

    padding: 18px 10px;
    color: black;
    display: flex;
    flex-direction: column;
  }
  .leave-wfh-title {
    display: flex;
    justify-content: space-between;
  }
  .leave-wfh-details-list {
    display: flex;
    justify-content: space-between;
    background-color: #edecec;
    text-align: center;
    margin: 5px;
    width: 92vw;
    height: 30px;
    padding: 5px;
    border-radius: 3px;
  }
  .approve-page {
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .name-card {
    padding: 2rem;
  }
  .name-card > div {
    font-size: x-large;
  }
  table {
    font-family: arial, sans-serif;
    width: 100%;
    margin: 30px auto;
    max-width: 90vw;
    background-color: #fff;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    border-collapse: collapse;
  }

  th {
    background-color: #4285f4;
    color: #fff;
    border: 1px solid #4285f4;
    text-align: center;
    padding: 12px;
  }

  .heading {
    text-align: center;
  }

  td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  th:hover {
    background-color: #3367d6;
  }

  tr:hover td {
    background-color: #e4f0fb;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 20px 0;
  }

  /* Style for the h3 heading */
  h3 {
    text-align: center;
    font-size: 24px;
    color: #333;
  }

  /* Style for the select elements */
  select {
    margin: 0 10px;
    padding: 5px;
    font-size: 16px;
  }

  /* Style for the button */
  button {
    display: block;
    margin: 20px auto;
    padding: 10px 20px;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
  }

  /* Style for the report data */
`

export default LeaveApprovalSc
